import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import { ReduxStateType } from "redux-store/types";

interface IFormEarlyRegistration {
  files: {
    originalFilename: string;
    path: string;
  }[];
  files_files: any[];
  startWorkingDate: string;
  registerLeaveId: "";
  leaveFromDate: string;
  leaveToDate: string;
  currentApproveStatus?: string;
  finalApproveStatus?: string;
  employeeCode: string;
  delete?: boolean;
  attachedFiles: any[];
  approvals: {
    account: string;
    departmentName: string;
    employeeCode: string;
    name: string;
    positionName: string;
    approverCode: string;
  }[];
}

const initialState: {
  formInput: IFormEarlyRegistration;
  status: ReduxStateType;
} = {
  formInput: {
    files: [],
    files_files: [],
    startWorkingDate: "",
    approvals: [],
    registerLeaveId: "",
    leaveFromDate: "",
    leaveToDate: "",
    employeeCode: "",
    delete: true,
    attachedFiles: [],
  },
  status: ReduxStateType.INIT,
};
const earlyRegistrationSlice = createSlice({
  name: "earlyRegistration",
  initialState,
  reducers: {
    updateEarlyRegistrationForm: (state, action) => {
      const keys = Object.keys(action.payload);
      for (let i = 0; i < keys.length; i++) {
        set(state.formInput, keys[i], action.payload[keys[i]]);
      }
    },
    setEarlyRegistrationFormInput: (state, action) => {
      Object.assign(state.formInput, action.payload);
    },
    earlyRegistrationStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    earlyRegistrationSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    earlyRegistrationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    earlyRegistrationReset: (state) => {
      state.formInput = initialState.formInput;
      state.status = ReduxStateType.INIT;
    },
  },
});

export const {
  updateEarlyRegistrationForm,
  setEarlyRegistrationFormInput,
  earlyRegistrationStart,
  earlyRegistrationSuccess,
  earlyRegistrationFailed,
  earlyRegistrationReset,
} = earlyRegistrationSlice.actions;

export default earlyRegistrationSlice.reducer;
